import { render, staticRenderFns } from "./addCourseBoxManage.vue?vue&type=template&id=23ffdcff"
import script from "./addCourseBoxManage.vue?vue&type=script&lang=js"
export * from "./addCourseBoxManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports